export enum CardContentPadding {
  SMALL = 'small',
  LARGE = 'large',
}
